module.exports = __webpack_public_path__ + "ff66eb8ec531024561b1c1ddab593e2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/icons/github.svg
// module id = 31
// module chunks = 0 1